import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

import PrimaryButton from "../common/PrimaryButton";
import SecondaryButton from "../common/SecondaryButton";
import GrowthDashboard from "./GrowthDashboard";

function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="hero-premium">
      <div className="hero-container">

        <div className="hero-content">

          <motion.div
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >

            <div className="hero-badge">
              Strategy • Marketing • Technology
            </div>

            <h1 className="hero-title">
              Build a Predictable
              <br />
              Growth Engine.
            </h1>

            <p className="hero-description">
              EkritFly helps ambitious businesses align
              strategy, marketing and technology to create
              measurable growth, stronger customer acquisition
              systems and scalable digital infrastructure.
            </p>

            <div className="hero-actions">
              <PrimaryButton
                onClick={() => navigate("/contact")}
              >
                Book Strategy Call
              </PrimaryButton>

              <SecondaryButton
                onClick={() =>
                  navigate("/free-growth-audit")
                }
              >
                Free Growth Audit
              </SecondaryButton>
            </div>

            <div className="hero-proof">

              <div>
                <h3>6+</h3>
                <span>Growth Services</span>
              </div>

              <div>
                <h3>6</h3>
                <span>Industry Verticals</span>
              </div>

              <div>
                <h3>360°</h3>
                <span>Growth Approach</span>
              </div>

            </div>

          </motion.div>

        </div>

        <motion.div
          className="hero-dashboard-wrapper"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <GrowthDashboard />
        </motion.div>

      </div>
    </section>
  );
}

export default HeroSection;